/* ============================================================
   KROQ — Composez votre trio (sections/kroq-trio.liquid)

   Le visiteur choisit trois jouets (le même peut revenir), une variante
   pour chacun, puis ajoute les trois au panier en une fois. La remise
   n'est PAS calculée ici : c'est une remise automatique Shopify qui
   s'applique au panier. Le total affiché n'est qu'une estimation,
   présentée comme telle.

   Ajout au panier : /cart/add.js avec les trois lignes, puis l'événement
   `cart:update` d'Horizon (comme kroq-cart.js) pour redessiner et ouvrir
   le tiroir.
   ============================================================ */
(function () {
  'use strict';

  var TAILLE = 3;

  function formater(centimes, modele) {
    var v = (centimes / 100);
    function milliers(n, sep) { return n.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    function decoupe(val, dec, sepM, sepD) {
      var fixe = val.toFixed(dec).split('.');
      return milliers(fixe[0], sepM) + (dec ? sepD + fixe[1] : '');
    }
    return (modele || '{{amount_with_comma_separator}} €').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, nom) {
      switch (nom) {
        case 'amount': return decoupe(v, 2, ',', '.');
        case 'amount_no_decimals': return decoupe(v, 0, ',', '.');
        case 'amount_with_comma_separator': return decoupe(v, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return decoupe(v, 0, '.', ',');
        case 'amount_with_space_separator': return decoupe(v, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return decoupe(v, 2, "'", '.');
        default: return decoupe(v, 2, ' ', ',');
      }
    });
  }

  function init(racine) {
    if (racine.dataset.pret) return;
    racine.dataset.pret = '1';

    var donnees;
    try { donnees = JSON.parse(racine.querySelector('[data-trio-donnees]').textContent); } catch (e) { return; }
    var produits = {};
    donnees.produits.forEach(function (p) { produits[p.handle] = p; });
    var remise = donnees.remise;
    var modele = donnees.format;
    // Les traductions arrivent échappées pour le HTML (&#39; …) : on les
    // décode une fois, puisqu'elles sont posées en textContent.
    var textes = {};
    var decodeur = document.createElement('textarea');
    Object.keys(donnees.textes).forEach(function (k) {
      decodeur.innerHTML = donnees.textes[k];
      textes[k] = decodeur.value;
    });

    var choix = [];
    var cases = racine.querySelector('[data-trio-cases]');
    var total = racine.querySelector('[data-trio-total]');
    var avant = racine.querySelector('[data-trio-avant]');
    var economie = racine.querySelector('[data-trio-economie]');
    var compteur = racine.querySelector('[data-trio-compteur]');
    var bouton = racine.querySelector('[data-trio-ajouter]');
    var statut = racine.querySelector('[data-trio-statut]');

    racine.classList.add('kroq-trio--js');

    function annoncer(msg) { statut.textContent = ''; setTimeout(function () { statut.textContent = msg; }, 30); }

    function dessiner() {
      cases.innerHTML = '';
      for (var i = 0; i < TAILLE; i++) {
        var li = document.createElement('li');
        li.className = 'kroq-trio__case';
        var c = choix[i];
        if (c) {
          var p = produits[c.handle];
          var v = p.variantes.filter(function (x) { return String(x.id) === String(c.id); })[0];
          li.classList.add('is-pleine');
          li.innerHTML =
            (p.image ? '<img src="' + p.image + '" alt="" width="64" height="64">' : '<span class="kroq-trio__vide"></span>') +
            '<span class="kroq-trio__case-info"><span class="kroq-trio__case-nom"></span>' +
            '<span class="kroq-trio__case-var"></span></span>' +
            '<button type="button" class="kroq-trio__retirer" data-index="' + i + '"></button>';
          li.querySelector('.kroq-trio__case-nom').textContent = p.titre;
          li.querySelector('.kroq-trio__case-var').textContent =
            (v.titre && v.titre !== 'Default Title' ? v.titre + ' · ' : '') + formater(v.prix, modele);
          var retirer = li.querySelector('.kroq-trio__retirer');
          retirer.textContent = '×';
          retirer.setAttribute('aria-label', textes.retirer.replace('%s', p.titre));
        } else {
          li.innerHTML = '<span class="kroq-trio__vide" aria-hidden="true">' + (i + 1) + '</span>' +
            '<span class="kroq-trio__case-info"><span class="kroq-trio__case-var">' + textes.case_vide + '</span></span>';
        }
        cases.appendChild(li);
      }

      var somme = choix.reduce(function (s, c) {
        var v = produits[c.handle].variantes.filter(function (x) { return String(x.id) === String(c.id); })[0];
        return s + v.prix;
      }, 0);
      var complet = choix.length === TAILLE;
      var remisee = Math.round(somme * (100 - remise) / 100);
      compteur.textContent = textes.compteur.replace('%n', choix.length);
      avant.textContent = complet ? formater(somme, modele) : '';
      avant.hidden = !complet;
      total.textContent = formater(complet ? remisee : somme, modele);
      var reste = TAILLE - choix.length;
      economie.textContent = complet
        ? textes.economie.replace('%s', formater(somme - remisee, modele))
        : (reste === 1 ? textes.encore_un : textes.encore.replace('%n', reste));
      bouton.disabled = !complet;

      racine.querySelectorAll('[data-trio-choisir]').forEach(function (b) { b.disabled = choix.length >= TAILLE || b.dataset.dispo === 'false'; });
    }

    racine.addEventListener('click', function (e) {
      var choisir = e.target.closest('[data-trio-choisir]');
      if (choisir) {
        if (choix.length >= TAILLE) return;
        var carte = choisir.closest('[data-trio-produit]');
        var handle = carte.dataset.trioProduit;
        var select = carte.querySelector('select');
        var id = select ? select.value : produits[handle].variantes[0].id;
        choix.push({ handle: handle, id: id });
        dessiner();
        annoncer(textes.ajoute.replace('%s', produits[handle].titre).replace('%n', choix.length));
        return;
      }
      var retirer = e.target.closest('.kroq-trio__retirer');
      if (retirer) {
        var index = Number(retirer.dataset.index);
        var nom = produits[choix[index].handle].titre;
        choix.splice(index, 1);
        dessiner();
        annoncer(textes.retire.replace('%s', nom));
      }
    });

    // Le prix de la carte suit la variante choisie.
    racine.addEventListener('change', function (e) {
      if (!e.target.matches('[data-trio-produit] select')) return;
      var carte = e.target.closest('[data-trio-produit]');
      var p = produits[carte.dataset.trioProduit];
      var v = p.variantes.filter(function (x) { return String(x.id) === e.target.value; })[0];
      var prix = carte.querySelector('[data-trio-prix]');
      if (v && prix) prix.textContent = formater(v.prix, modele);
    });

    bouton.addEventListener('click', function () {
      if (choix.length !== TAILLE || bouton.disabled) return;
      bouton.disabled = true;
      bouton.setAttribute('aria-busy', 'true');

      var lignes = {};
      choix.forEach(function (c) { lignes[c.id] = (lignes[c.id] || 0) + 1; });
      var items = Object.keys(lignes).map(function (id) { return { id: Number(id), quantity: lignes[id] }; });

      var tiroir = document.querySelector('cart-items-component[data-drawer]');
      var sectionId = tiroir ? tiroir.getAttribute('data-section-id') : null;
      var corps = { items: items };
      if (sectionId) { corps.sections = [sectionId]; corps.sections_url = window.location.pathname; }
      var racineUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(racineUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(corps)
      }).then(function (res) {
        if (!res.ok) throw new Error('cart/add ' + res.status);
        // Un 200 veut dire que les jouets SONT au panier. Si la réponse est
        // illisible (constaté derrière le proxy de `shopify theme dev`), on
        // poursuit sans les sections : ne jamais annoncer un échec pour un
        // ajout qui a réussi.
        return res.text().then(function (texte) {
          try { return JSON.parse(texte); } catch (e) { return {}; }
        });
      }).then(function (data) {
        return fetch(racineUrl + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; })
          .then(function (panier) {
            bouton.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: panier,
                sourceId: 'kroq-trio',
                data: { source: 'kroq-trio', itemCount: panier ? panier.item_count : 0, sections: data.sections || null }
              }
            }));
            choix = [];
            dessiner();
            annoncer(textes.succes);
          });
      }).catch(function () {
        annoncer(textes.erreur);
        bouton.disabled = false;
      }).then(function () {
        bouton.removeAttribute('aria-busy');
      });
    });

    dessiner();
  }

  function demarrer() {
    document.querySelectorAll('[data-kroq-trio]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
